import { toNumber } from '../../../../core/utils/lp-backend';
import { OrderHistory } from '../../presentation/redux/types/settings-types';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.order_history`. */
export const editOrderHistory = async (order_history: OrderHistory): Promise<any> =>
  writeSettingsFields({
    order_history: { ...order_history, hours: toNumber(order_history?.hours) }
  });
